export default {
  title: '选择工具',
  dmaker: {
    title: '定制创意',
    subtitle: '您在Mindworks定制的全部广告素材',
  },
  gmaker: {
    title: '互动广告制作',
    subtitle:
      '通过Mindworks提供的通用模板快速制作使用自由编辑器从0到1制作互动广告',
  },
  vmaker: {
    title: '视频广告制作',
    subtitle: '智能剪辑 批量操作',
  },
}
